
import { axiosPost } from '../../axios/axios.js'
import CardPropertyTable from '../../components/Card/CardPropertyTable.vue'

export default {
  name: 'EmployeePropertySkudHistory',
  extends: CardPropertyTable,
  data: function () {
    return {
      intervalRows: null,
      useServerPagination: false,
      rowsPerPageOptions: [10, 25, 50],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: undefined,
        rowsNumberMessage: ''
      },
      ignorePageChange: false,

      // @Override
      initialSortFn: (r1, r2) => {
        return r2.time - r1.time
      }
    }
  },
  computed: {
    columns: function () {
      const columns = []
      columns.push(this.getColumnConfig('time', 'Время', 'datetime', { tdStyle: 'width: 150px;' }))
      columns.push(this.getColumnConfig({ name: 'action', label: 'Действие', type: 'string' }))
      columns.push(this.getColumnConfig({ name: 'details', label: 'Ключ', type: 'string' }))
      return columns
    },
    rows: function () {
      return this.intervalRows ? this.intervalRows : this.loading ? [] : this.propertyRows
    }
  },
  watch: {
    object: function () {
      this.resetPagination()
      this.updateIntervalRecords()
    },
    'tabProp.componentProps.interval': {
      handler: function () {
        this.resetPagination()
        this.updateIntervalRecords()
      },
      immediate: true
    }

  },
  methods: {
    onPageChanged: function (page) {
      if (!this.ignorePageChange) {
        this.updateIntervalRecords(page)
      }
    },
    onTableRequest: function (props) {
      if (props && props.pagination && props.pagination.rowsPerPage !== this.pagination.rowsPerPage) {
        this.updateIntervalRecords(props.pagination.page, props.pagination.rowsPerPage)
      }
    },
    resetPagination: function () {
      this.ignorePageChange = true
      this.pagination.page = 1
      // this.pagination.rowsPerPage = 10
      this.pagination.rowsNumber = undefined
    },
    updateIntervalRecords: function (page, rowsPerPage) {
      const interval = this.tabProp.componentProps.interval
      if (interval && interval.startTime != null && interval.endTime != null) {
        if (!page) {
          page = this.pagination.page || 1
        }
        if (!rowsPerPage) {
          rowsPerPage = this.pagination.rowsPerPage || 10
        }
        const startIndex = (page - 1) * rowsPerPage
        this.getIntervalRecords(interval.startTime, interval.endTime, startIndex, rowsPerPage)
          .then(result => {
            this.ignorePageChange = true
            const rows = result.data || []
            if (rows.length || page === 1) {
              rows.sort(this.initialSortFn)
              this.intervalRows = rows
              this.pagination.page = page
              this.pagination.rowsPerPage = rowsPerPage
              if (startIndex === 0) {
                this.pagination.rowsNumber = result.total
              }
              this.pagination.rowsNumberMessage = '' + (startIndex + 1) + '-' + (startIndex + rows.length) + ' из ' + this.pagination.rowsNumber
            } else {
              this.pagination.page = page - 1
              this.pagination.rowsNumber = this.pagination.rowsNumber - 1
            }
            this.useServerPagination = true
            this.$nextTick(() => {
              this.ignorePageChange = false
            })
          })
      } else {
        this.intervalRows = null
        this.useServerPagination = false
      }
    },
    getIntervalRecords: function (fromTime, toTime, offset = 0, count = 10) {
      this.loading = true
      return axiosPost({
        url: '/vis/skudemployeeperiodnew/onetouch',
        data: { id: this.object.id, from: fromTime, to: toTime, offset: offset, count: count },
        config: { headers: { 'Content-Type': 'application/json' } },
        onSuccess: (response) => response.data,
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка получения данных СКУД',
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },

    // @Override
    getTrStyle: function (row) {
      if (row.action.toLowerCase().includes('вход')) {
        return 'background-color: #ceffce !important;'
      } else if (row.action.toLowerCase().includes('выход')) {
        return 'background-color: #ffcece !important;'
      }
    }
  }
}
